import iconMobileHome from '../../../img/ico_mobile_home.png';
import iconMobileHome2X from '../../../img/ico_mobile_home@2x.png';
import iconMobileEdit from '../../../img/ico_mobile_edit.png';
import iconMobileEdit2X from '../../../img/ico_mobile_edit@2x.png';
import iconMobileLink from '../../../img/ico_mobile_link.png';
import iconMobileLink2X from '../../../img/ico_mobile_link@2x.png';
import iconMobileDownload from '../../../img/ico_mobile_download.png';
import iconMobileDownload2X from '../../../img/ico_mobile_download@2x.png';
import iconMobileUser from '../../../img/ico_mobile_user.png';
import iconMobileUser2X from '../../../img/ico_mobile_user@2x.png';
import styled, { css } from 'styled-components';
import ga from '../../../utils/gaConnect';
import { useDocInfoSliceSelector } from '../../../store/modules/docInfo';
import { useAppDataSliceSelector } from '../../../store/modules/appData';
import { useDispatch } from 'react-redux';
import { showAppInstall } from '../../../store/modules/popup';
import { DIALOG_TYPE, DOC_FORMAT_CONFIG_VALUES, PRODUCT_TYPE, URLS } from '../../../define/global';
import { getFormatImg, useGetHomeURLWithProductType } from '../../../utils/util';
import { useCallback } from 'react';

export const HEADER_CONTAINER_HEIGHT_MOBILE = 48;

const MobileHeaderContainer = styled.header`
  height: ${HEADER_CONTAINER_HEIGHT_MOBILE}px;
  padding: 0 16px 0 10px;
  display: flex;
`;

const MobileTitleFileInfo = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  min-width: 50px;
  //padding-top: 5px 0 5px 0;
  box-sizing: border-box;
  align-items: center;
`;

const MobileFileName = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #2f3133;
  margin: 0;
  flex: 1;
  margin-left: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
`;

const MobileTitleMenu = styled.ul`
  margin: 0;
  display: flex;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  list-style-type: none;
  width: 100px;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
`;

const MobileTitleMenuItem = styled.li`
  & + & {
    margin-left: 12px;
  }
  width: 25px;
  height: 26px;
  display: flex;
  align-items: center;
  //padding: 3px;
  box-sizing: border-box;
`;

const MobileIcon = styled.img`
  display: inline-block;
  width: 20px;
  min-width: 20px;
  height: 20px;

  ${(props) =>
    props.menuItem &&
    css`
      width: 24px;
      height: 24px;
    `};
`;

export default function HeaderMobile({ onClick, onClickMobileDocumentDownload }) {
  const dispatch = useDispatch();
  const docInfo = useDocInfoSliceSelector();
  const appData = useAppDataSliceSelector();
  const isShareView = appData.shareId !== '';
  const getHomeURLWithProductType = useGetHomeURLWithProductType();

  const { formatImgMobile, formatImgMobile2x } = getFormatImg(
    DOC_FORMAT_CONFIG_VALUES.sdk.documnetType
  );

  const prodTypeAll = Object.values(PRODUCT_TYPE);

  const prodTypeExceptDrive = prodTypeAll.filter(
    (type) => type !== PRODUCT_TYPE.WITH_GOOGLE_DRIVE && type !== PRODUCT_TYPE.WITH_DROPBOX
  );

  const Menus = [
    {
      name: 'home',
      supportProdType: prodTypeExceptDrive,
      onlyShareView: undefined,
      component: (
        <MobileTitleMenuItem
          key="home"
          onClick={() => {
            const label = isShareView ? '모바일공유' : '모바일뷰';
            ga.event({ category: '이동', action: '홈바로가기', label });
            window.open(
              getHomeURLWithProductType(DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()),
              '_self',
              'noopener,noreferrer'
            );
          }}>
          <MobileIcon src={iconMobileHome} srcSet={iconMobileHome2X} menuItem />
        </MobileTitleMenuItem>
      )
    },
    {
      name: 'edit',
      supportProdType: prodTypeExceptDrive.filter((type) => type !== PRODUCT_TYPE.WITH_WHALE_SPACE),
      onlyShareView: undefined,
      component: (
        <MobileTitleMenuItem
          key="edit"
          onClick={() => {
            let gaData = { category: '모바일 앱', action: '편집 버튼' };
            if (isShareView) gaData.label = '공유뷰';
            ga.event(gaData);
            dispatch(showAppInstall());
          }}>
          <MobileIcon src={iconMobileEdit} srcSet={iconMobileEdit2X} menuItem />
        </MobileTitleMenuItem>
      )
    },
    {
      name: 'download',
      supportProdType: prodTypeExceptDrive,
      onlyShareView: true,
      component: (
        <MobileTitleMenuItem key="download" onClick={onClickMobileDocumentDownload}>
          <MobileIcon src={iconMobileDownload} srcSet={iconMobileDownload2X} menuItem />
        </MobileTitleMenuItem>
      )
    },
    {
      name: 'download-share',
      supportProdType: prodTypeExceptDrive,
      onlyShareView: false,
      component: (
        <MobileTitleMenuItem
          key="share"
          onClick={() => onClick(DIALOG_TYPE.DIALOG_SHARE_LINK_DOCUMENT)}>
          <MobileIcon src={iconMobileLink} srcSet={iconMobileLink2X} menuItem />
        </MobileTitleMenuItem>
      )
    },
    {
      name: 'userInfo',
      supportProdType: [PRODUCT_TYPE.WITH_WHALE_SPACE],
      onlyShareView: false,
      component: (
        <MobileTitleMenuItem
          key="userInfo"
          onClick={() => onClick(DIALOG_TYPE.DIALOG_WHALESPACE_USERINFO)}>
          <MobileIcon src={iconMobileUser} srcSet={iconMobileUser2X} menuItem />
        </MobileTitleMenuItem>
      )
    }
  ];

  const getSupportMenuItem = useCallback(
    () =>
      Menus.filter((menu) => menu.supportProdType.includes(appData.productType))
        .filter((memu) => memu.onlyShareView === undefined || memu.onlyShareView === isShareView)
        .map((item) => item.component),
    []
  );

  return (
    <MobileHeaderContainer>
      <MobileTitleFileInfo>
        <MobileIcon src={formatImgMobile} srcSet={formatImgMobile2x} />
        <MobileFileName>{docInfo.fileName}</MobileFileName>
      </MobileTitleFileInfo>
      <MobileTitleMenu>{getSupportMenuItem()}</MobileTitleMenu>
    </MobileHeaderContainer>
  );
}
